export default {"src":"/_next/static/media/scroll-top.4d773f7f.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};